import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import appConfigOnPremDev from "./appConfigOnPremDev.js"
import appConfigOnPremProd from "./appConfigOnPremProd.js"
import appConfigAliCloudDev from "./appConfigAliCloudDev.js"
import appConfigAliCloudProd from "./appConfigAliCloudProd.js"
import { COVERGO_SAAS_PROD } from "../consts.js"

const BOC_ONPREM_DEV = {
	COVERGO_GRAPHQL: "http://172.168.1.61:32100/graphql",
	COVERGO_FILE_SYSTEM: "http://172.168.1.61:32100/api/v1/files"
}

const BOC_ONPREM_PROD = {
	COVERGO_GRAPHQL: "http://172.168.1.63:32100/graphql",
	COVERGO_FILE_SYSTEM: "http://172.168.1.63:32100/api/v1/files"
}

const BOC_ALICLOUD_DEV = {
	COVERGO_GRAPHQL: "http://192.168.22.21:32100/graphql",
	COVERGO_FILE_SYSTEM: "http://192.168.22.21:32100/api/v1/files"
}

const BOC_ALICLOUD_PROD = {
	COVERGO_GRAPHQL: "http://192.168.202.22:32100/graphql",
	COVERGO_FILE_SYSTEM: "http://192.168.202.22:32100/api/v1/files"
}

export const boc = {
	"boc-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_PROD },
	"172.168.1.61:32106": { appConfig: appConfigOnPremDev, envConfig: BOC_ONPREM_DEV },
	"172.168.1.63:32106": {
		appConfig: appConfigOnPremProd,
		envConfig: BOC_ONPREM_PROD
	},
	"192.168.22.21:32106": { appConfig: appConfigAliCloudDev, envConfig: BOC_ALICLOUD_DEV },
	"192.168.202.22:32106": {
		appConfig: appConfigAliCloudProd,
		envConfig: BOC_ALICLOUD_PROD
	}
}
